/* Main constants */
const HORIZONTAL_KEY_DELAY = 150; // Delay for horizontal key press in ms
const VERTICAL_KEY_DELAY = 500; // Delay for vertical key press in ms
const TIMELINE_OFFSET = 4; // EPG chunk time offset in hours
const PAGINATION = {
  CHANNELS_GRID: {
    CHUNK_SIZE: 10,
    PREVIOUS_LOAD_OFFSET: 1,
    PAGE_SIZE: 21, // 0x7fffffff, // Maximum allowed value -> 2^32 - 1
  },
};
const THRESHOLD = {
  CHANNELS_GRID: {
    REAR: 4,
    FRONT: 10,
  },
  DEFAULT: {
    REAR: 1, // Items to keep behind the current rail
    FRONT: 3, // Items to keep after the current rail
  },
};

export {
  TIMELINE_OFFSET,
  HORIZONTAL_KEY_DELAY,
  VERTICAL_KEY_DELAY,
  PAGINATION,
  THRESHOLD,
};
